import { Navigate, useParams } from 'react-router-dom';

import { useRoutes } from '../../hooks/useRoutes';
import { useEffect, useState } from 'react';
import { getModuleById, getSubModulesForModule, Module } from '../../api/module';
import useThrowAsyncError from '../../hooks/useThrowAsyncError';

type LaunchMaterialRouteParams = 'selectedModule' | 'medialinkId' | 'superModule' | 'nodeId';

export default function LaunchMaterial() {
  const { superModule, selectedModule, medialinkId, nodeId } = useParams<LaunchMaterialRouteParams>();
  const handleError = useThrowAsyncError();
  const { buildAbsolutePath } = useRoutes();

  const [resolvedModule, setResolvedModule] = useState<Omit<Module, 'subModules'> & { subModules: Module[] }>();

  useEffect(() => {
    if (!superModule || medialinkId) return;
    Promise.all([getModuleById(superModule), getSubModulesForModule(superModule)])
      .then(([module, subModules]) => setResolvedModule({ ...module, subModules: subModules.data }))
      .catch(handleError);
  }, [handleError, medialinkId, superModule]);

  if (medialinkId) {
    const path = buildAbsolutePath(['LINKED_MATERIAL_LINK']);

    const query = new URLSearchParams();
    query.set('moduleId', selectedModule!);
    query.set('medialinkIds', medialinkId);

    return <Navigate to={`${path}?${query.toString()}`} replace />;
  }

  if (!resolvedModule) return null;

  const selectedModuleSlug =
    superModule !== selectedModule
      ? resolvedModule.subModules.find(x => x.id === selectedModule)?.slug
      : resolvedModule.slug;

  if (!selectedModuleSlug) throw new Error('Selected module not found');

  const path = buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.CONTENT.TOC'], {
    subjectSlug: resolvedModule.subjectSlug,
    methodSlug: resolvedModule.methodSlug,
    moduleSlug: resolvedModule.slug,
    selectedModuleSlug: selectedModuleSlug!,
    nodeId: nodeId!,
  });

  return <Navigate to={path} />;
}
